<template>
    <div class="details">
        <div class="header">
            <div class="headerBox">
                <h4 class="title">{{title}}</h4>
                <div @click="toggle(!showDetails)" class="showItem" v-if="showBtn">
                    <em :class="{'el-icon-arrow-down': !showDetails, 'el-icon-arrow-up': showDetails }"></em>
                    {{showDetails ? '收起' : '展开'}}
                </div>
            </div>
        </div>
        <div class="content" v-show="showDetails">
            <div class="contentBox">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDetails: true,
        }
    },
    props: {
        title: String,
        showBtn: Boolean,
        showContent: Boolean,
    },
    mounted() {
        this.showDetails = this.showContent;
    },
    methods: {
        toggle(data) {
            this.showDetails = data;
        }
    }
}
</script>

<style scoped>
.details {
    border-radius: 4px;
    background: #fff;
    margin-top: 15px;
}
.header{
    padding: 10px 24px 0 24px;
    height: 48px;
}
.headerBox {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-content: center;
}
.title {
    margin: 0;
    line-height: 32px;
}
.title::before{
    margin-left: 4px;
    content: "|";
    margin-right: 8px;
    width: 2px;
    height: 14px;
    color: #1989fa;
    background: #1989fa;
}
.showItem{
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    cursor: pointer;
    color: #1989fa;
}
.content {
    padding: 0 24px;
}
.contentBox {
    padding: 10px 0;
    border-top: 1px solid rgba(0, 0, 0,0.1);
}
</style>
